import React, { useRef, useEffect, useState } from 'react';
import Quagga from '@ericblade/quagga2';
import { toast } from 'react-toastify';

const BarcodeScanner = ({ onCodeDetected, code, validation, historyDisplay, setHistoryDisplay, historyRef }) => {
  const [torchOn, setTorchOn] = useState(false);
  const [hasTorch, setHasTorch] = useState(false);
  const videoTrackRef = useRef(null);
  const reCheckTime = 300;

  useEffect(() => {
    const initCamera = async () => {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });
      const videoTrack = stream.getVideoTracks()[0];
      const capabilities = videoTrack.getCapabilities();
      if (capabilities.zoom) {
        videoTrack.applyConstraints({
          advanced: [{ zoom: 2 }], // 2x zoom
        });
      }
      try {
        Quagga.init(
          {
            inputStream: {
              name: 'Live',
              type: 'LiveStream',
              target: document.querySelector('#container'),
              stream: stream,
              constraints: {
                facingMode: { exact: 'environment' },
              },
              locator: {
                halfSample: false,
              },
            },
            decoder: {
              readers: ['code_128_reader', 'ean_reader', 'upc_reader'],
            },
            locate: true,
          },
          async (err) => {
            if (err) {
              console.error(err);
              toast.error('このデバイスにはカメラがないか、カメラへのアクセス許可がありません。');
              onCodeDetected('');
              return;
            }
            Quagga.start();
            const track = Quagga.CameraAccess.getActiveTrack();
            videoTrackRef.current = track;
            if (track && track.getCapabilities) {
              const capabilities = track.getCapabilities();
              if (capabilities.torch) {
                setHasTorch(true);
              }
            }
          },
        );

        Quagga.onProcessed((result) => {
          const ctx = Quagga.canvas.ctx.overlay;
          const canvas = Quagga.canvas.dom.overlay;
          ctx.clearRect(0, 0, parseInt(canvas.width), parseInt(canvas.height));
          const w = canvas.width;
          const h = canvas.height;
          ctx.clearRect(0, 0, w, h);
          ctx.beginPath();
          ctx.moveTo(0, h / 2);
          ctx.lineTo(w, h / 2);
          ctx.lineWidth = 5;
          ctx.strokeStyle = 'rgba(255, 0, 0, 0.8)';
          ctx.stroke();

          // if (result?.box) {
          //   Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, ctx, {
          //     color: 'blue',
          //     lineWidth: 2,
          //   });
          // }
          // if (result?.codeResult?.code) {
          //   Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, ctx, {
          //     color: 'red',
          //     lineWidth: 3,
          //   });
          // }
        });

        Quagga.onDetected((result) => {
          const detected = result.codeResult?.code;
          if (!detected) return;

          const now = Date.now();
          const hist = historyRef.current;

          if (hist.length && now - hist[hist.length - 1].time < reCheckTime) {
            return;
          }

          hist.push({ code: detected, time: now });
          if (hist.length > 3) hist.shift();
          setHistoryDisplay(hist.map((h) => h.code));

          if (validation && !validation(detected)) {
            // toast.error(`"${detected}" バーコードが正しくありません。`);
            return;
          }
          if (hist.length < 3 || !hist.every((h) => h.code === detected)) {
            return;
          }
          onCodeDetected(detected);
        });
      } catch (err) {
        console.error('Error accessing the camera:', err);
        toast.error('このデバイスにはカメラがないか、カメラへのアクセス許可がありません。');
      }
    };
    initCamera();
    return () => Quagga.stop();
  }, []);

  const toggleTorch = async () => {
    const track = videoTrackRef.current;
    if (!track) return;
    try {
      await track.applyConstraints({ advanced: [{ torch: !torchOn }] });
      setTorchOn(!torchOn);
    } catch (err) {}
  };

  return (
    <div>
      <style>
        {`
          #container > video, #container > canvas {
            width: 100%;
          }
          #container > canvas {
            z-index: 1;
            position: absolute;
            left: 0;
            top: 0;
          }
        `}
      </style>
      <div id="container" style={{ position: 'relative' }}></div>
      {hasTorch && (
        <div className="flex justify-center items-center mt-3">
          <button className="bg-blue-btn-primary text-white rounded-md p-2" onClick={toggleTorch}>
            ライト: {torchOn ? 'オフ' : 'オン'}
          </button>
        </div>
      )}
      {/* <div>{code}</div> */}
      {/* <div>
        Scan History Code:
        {historyDisplay.length > 0 ? (
          <ul className="list-disc list-inside">
            {historyDisplay.map((c, idx) => (
              <li key={idx}>{c}</li>
            ))}
          </ul>
        ) : (
          ' —'
        )}
      </div> */}
    </div>
  );
};

export default BarcodeScanner;
